import actions from '@/store/modules/feedback/actions.js'
import getters from '@/store/modules/feedback/getters.js'

export default {
  actions,
  getters
}
